export default __webpack_public_path__ + "static/media/party-erik.a44bd77a.jpeg";